// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessInsights_bi__content__BYivx {
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .BusinessInsights_bi__content__BYivx {
    grid-template-columns: repeat(2, 1fr);
  }
}
.BusinessInsights_bi__income__siwtm {
  background-color: var(--color-green);
  color: var(--color-white);
  height: 12.5rem;
}
.BusinessInsights_bi__profit__Oj8dS {
  background-color: var(--color-yellow);
  height: 12.5rem;
}
.BusinessInsights_bi__credit__jrVAT {
  background-color: var(--color-primary-3);
  height: 12.5rem;
}
.BusinessInsights_bi__expenses__cv4WE {
  background-color: var(--color-light-red);
  height: 12.5rem;
}
.BusinessInsights_bi__sales__AGZ6t {
  background-color: var(--color-primary-7);
  height: 12.5rem;
}
.BusinessInsights_bi__health__rkJHQ {
  background-color: var(--color-green-2);
  height: 12.5rem;
}
.BusinessInsights_bi__info__rX42z {
  margin-top: 3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
}
.BusinessInsights_bi__sideCards__9QtUT {
  display: grid;
  grid-template-columns: repeat(2, 49%);
  gap: 3rem;
  box-sizing: border-box;
  margin-top: 6rem;
}
@media only screen and (max-width: 56.25em) {
  .BusinessInsights_bi__sideCards__9QtUT {
    grid-template-columns: 80%;
    justify-content: center;
  }
}
@media only screen and (max-width: 31.25em) {
  .BusinessInsights_bi__sideCards__9QtUT {
    grid-template-columns: 100%;
  }
}
.BusinessInsights_bi__mainCards__T45IR {
  height: 45rem;
  width: 100%;
  box-sizing: border-box;
  padding: 4rem 2rem 2rem 2rem;
  background-color: var(--color-fash-primary-3);
  border-radius: 2rem;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P {
  height: -moz-fit-content;
  height: fit-content;
  min-height: 50rem;
  width: 100%;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 2rem;
  border: 2px solid var(--color-fash-primary-3);
  position: relative;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table {
  width: 100%;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table tbody > :not(:last-child) {
  margin-bottom: 1rem;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table tr {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table tr > :last-child {
  font-weight: 700;
  text-align: right;
}
.BusinessInsights_bi__mainCards__T45IR table {
  width: 100%;
}
.BusinessInsights_bi__mainCards__T45IR table tbody > :not(:last-child) {
  margin-bottom: 1rem;
}
.BusinessInsights_bi__mainCards__T45IR table tr {
  display: grid;
  grid-template-columns: 1fr 13fr 2fr;
}
.BusinessInsights_bi__mainCards__T45IR table tr > :last-child {
  font-weight: 700;
}

.BusinessInsights_card_top__kMUi4 {
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
}
@media only screen and (max-width: 37.5em) {
  .BusinessInsights_card_top__kMUi4 {
    font-size: var(--default-font-small);
  }
}
.BusinessInsights_card_top_icon__R7p8l {
  display: flex;
}
.BusinessInsights_card_top_icon__R7p8l > :first-child {
  margin-right: 1rem;
}
.BusinessInsights_card_top_filter__eFqqJ {
  display: flex;
}
.BusinessInsights_card_top_filter__eFqqJ > :first-child {
  margin-right: 3rem;
}
.BusinessInsights_card_top_pie__OuTpT {
  width: 100%;
}
.BusinessInsights_card_bottom__qXjE3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-top: 1rem;
}
.BusinessInsights_card_bottom__qXjE3 > :not(:last-child) {
  margin-right: 1rem;
}
.BusinessInsights_card_bottom_content__KpDGe {
  display: flex;
  align-items: center;
  font-size: var(--default-font-small);
}
.BusinessInsights_card_bottom_content__KpDGe img {
  height: 1.5rem;
  margin-right: 1rem;
}

.BusinessInsights_modalTable__Bvu7v table {
  width: 40rem;
}
.BusinessInsights_modalTable__Bvu7v table tbody > :not(:last-child) {
  margin-bottom: 2rem;
}
.BusinessInsights_modalTable__Bvu7v table tr {
  display: grid;
  grid-template-columns: 7fr 3fr;
}
.BusinessInsights_modalTable__Bvu7v table tr > :last-child {
  font-weight: 700;
}

.BusinessInsights_modalInfo__Smo1j {
  font-size: 3rem;
  color: var(--color-primary);
  position: relative;
  left: 20rem;
  margin-top: 3rem;
}

.BusinessInsights_terms__pAwNK {
  width: 40rem;
}
.BusinessInsights_terms__pAwNK span {
  font-weight: 700;
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/BusinessInsights/BusinessInsights.module.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AAFJ;AAII;EANF;IAOI,qCAAA;EADJ;AACF;AAIE;EACE,oCAAA;EACA,yBAAA;EACA,eAAA;AAFJ;AAKE;EACE,qCAAA;EACA,eAAA;AAHJ;AAME;EACE,wCAAA;EACA,eAAA;AAJJ;AAOE;EACE,wCAAA;EACA,eAAA;AALJ;AAQE;EACE,wCAAA;EACA,eAAA;AANJ;AASE;EACE,sCAAA;EACA,eAAA;AAPJ;AAUE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AARJ;AAWE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;AATJ;AAWI;EAPF;IAQI,0BAAA;IACA,uBAAA;EARJ;AACF;AAUI;EAZF;IAaI,2BAAA;EAPJ;AACF;AAUE;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,4BAAA;EACA,6CAAA;EACA,mBAAA;AARJ;AAUI;EACE,wBAAA;EAAA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;AARN;AASM;EACE,WAAA;AAPR;AASU;EACE,mBAAA;AAPZ;AAWQ;EACE,aAAA;EACA,8BAAA;AATV;AAWU;EACE,gBAAA;EACA,iBAAA;AATZ;AAeI;EACE,WAAA;AAbN;AAeQ;EACE,mBAAA;AAbV;AAiBM;EACE,aAAA;EACA,mCAAA;AAfR;AAiBQ;EACE,gBAAA;AAfV;;AAuBE;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AApBJ;AAsBI;EALF;IAMI,oCAAA;EAnBJ;AACF;AAqBI;EACE,aAAA;AAnBN;AAoBM;EACE,kBAAA;AAlBR;AAsBI;EACE,aAAA;AApBN;AAqBM;EACE,kBAAA;AAnBR;AAuBI;EACE,WAAA;AArBN;AAyBE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAvBJ;AAwBI;EACE,kBAAA;AAtBN;AAyBI;EACE,aAAA;EACA,mBAAA;EACA,oCAAA;AAvBN;AAyBM;EACE,cAAA;EACA,kBAAA;AAvBR;;AA8BE;EACE,YAAA;AA3BJ;AA6BM;EACE,mBAAA;AA3BR;AA+BI;EACE,aAAA;EACA,8BAAA;AA7BN;AA+BM;EACE,gBAAA;AA7BR;;AAmCA;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAhCF;;AAmCA;EACE,YAAA;AAhCF;AAiCE;EACE,gBAAA;EACA,2BAAA;AA/BJ","sourcesContent":["@import \"../variables/breakpoints\";\n\n.bi {\n  &__content {\n    display: grid;\n    box-sizing: border-box;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  &__income {\n    background-color: var(--color-green);\n    color: var(--color-white);\n    height: 12.5rem;\n  }\n\n  &__profit {\n    background-color: var(--color-yellow);\n    height: 12.5rem;\n  }\n\n  &__credit {\n    background-color: var(--color-primary-3);\n    height: 12.5rem;\n  }\n\n  &__expenses {\n    background-color: var(--color-light-red);\n    height: 12.5rem;\n  }\n\n  &__sales {\n    background-color: var(--color-primary-7);\n    height: 12.5rem;\n  }\n\n  &__health {\n    background-color: var(--color-green-2);\n    height: 12.5rem;\n  }\n\n  &__info {\n    margin-top: 3rem;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n  }\n\n  &__sideCards {\n    display: grid;\n    grid-template-columns: repeat(2, 49%);\n    gap: 3rem;\n    box-sizing: border-box;\n    margin-top: 6rem;\n\n    @media only screen and (max-width: $bp-900) {\n      grid-template-columns: 80%;\n      justify-content: center;\n    }\n\n    @media only screen and (max-width: $bp-500) {\n      grid-template-columns: 100%;\n    }\n  }\n\n  &__mainCards {\n    height: 45rem;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 4rem 2rem 2rem 2rem;\n    background-color: var(--color-fash-primary-3);\n    border-radius: 2rem;\n\n    &_b {\n      height: fit-content;\n      min-height: 50rem;\n      width: 100%;\n      box-sizing: border-box;\n      padding: 2rem;\n      border-radius: 2rem;\n      border: 2px solid var(--color-fash-primary-3);\n      position: relative;\n      table {\n        width: 100%;\n        tbody {\n          & > :not(:last-child) {\n            margin-bottom: 1rem;\n          }\n        }\n\n        tr {\n          display: grid;\n          grid-template-columns: 1fr 2fr;\n\n          & > :last-child {\n            font-weight: 700;\n            text-align: right;\n          }\n        }\n      }\n    }\n\n    table {\n      width: 100%;\n      tbody {\n        & > :not(:last-child) {\n          margin-bottom: 1rem;\n        }\n      }\n\n      tr {\n        display: grid;\n        grid-template-columns: 1fr 13fr 2fr;\n\n        & > :last-child {\n          font-weight: 700;\n        }\n      }\n    }\n  }\n}\n\n.card {\n  &_top {\n    display: flex;\n    justify-content: space-between;\n    margin: 2rem 0;\n\n    @media only screen and (max-width: $bp-600) {\n      font-size: var(--default-font-small);\n    }\n\n    &_icon {\n      display: flex;\n      & > :first-child {\n        margin-right: 1rem;\n      }\n    }\n\n    &_filter {\n      display: flex;\n      & > :first-child {\n        margin-right: 3rem;\n      }\n    }\n\n    &_pie {\n      width: 100%;\n    }\n  }\n\n  &_bottom {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    margin-top: 1rem;\n    & > :not(:last-child) {\n      margin-right: 1rem;\n    }\n\n    &_content {\n      display: flex;\n      align-items: center;\n      font-size: var(--default-font-small);\n\n      img {\n        height: 1.5rem;\n        margin-right: 1rem;\n      }\n    }\n  }\n}\n\n.modalTable {\n  table {\n    width: 40rem;\n    tbody {\n      & > :not(:last-child) {\n        margin-bottom: 2rem;\n      }\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: 7fr 3fr;\n\n      & > :last-child {\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n.modalInfo {\n  font-size: 3rem;\n  color: var(--color-primary);\n  position: relative;\n  left: 20rem;\n  margin-top: 3rem;\n}\n\n.terms {\n  width: 40rem;\n  span {\n    font-weight: 700;\n    color: var(--color-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bi__content": `BusinessInsights_bi__content__BYivx`,
	"bi__income": `BusinessInsights_bi__income__siwtm`,
	"bi__profit": `BusinessInsights_bi__profit__Oj8dS`,
	"bi__credit": `BusinessInsights_bi__credit__jrVAT`,
	"bi__expenses": `BusinessInsights_bi__expenses__cv4WE`,
	"bi__sales": `BusinessInsights_bi__sales__AGZ6t`,
	"bi__health": `BusinessInsights_bi__health__rkJHQ`,
	"bi__info": `BusinessInsights_bi__info__rX42z`,
	"bi__sideCards": `BusinessInsights_bi__sideCards__9QtUT`,
	"bi__mainCards": `BusinessInsights_bi__mainCards__T45IR`,
	"bi__mainCards_b": `BusinessInsights_bi__mainCards_b__+pL9P`,
	"card_top": `BusinessInsights_card_top__kMUi4`,
	"card_top_icon": `BusinessInsights_card_top_icon__R7p8l`,
	"card_top_filter": `BusinessInsights_card_top_filter__eFqqJ`,
	"card_top_pie": `BusinessInsights_card_top_pie__OuTpT`,
	"card_bottom": `BusinessInsights_card_bottom__qXjE3`,
	"card_bottom_content": `BusinessInsights_card_bottom_content__KpDGe`,
	"modalTable": `BusinessInsights_modalTable__Bvu7v`,
	"modalInfo": `BusinessInsights_modalInfo__Smo1j`,
	"terms": `BusinessInsights_terms__pAwNK`
};
export default ___CSS_LOADER_EXPORT___;
